const isEqual = require('@helpers/lodash.isequal');

const isObject = (obj) => {
  return (obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Number));
};

const compact = (a) => {
  return a.filter(v => v);
};

const omit = (obj, props, fn) => {
  if (!isObject(obj)) return {};

  if (typeof props === 'function') {
    fn = props;
    props = [];
  }

  if (typeof props === 'string') {
    props = [props];
  }

  const isFunction = typeof fn === 'function';
  const keys = Object.keys(obj);
  const res = {};

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const val = obj[key];

    if (!props || (props.indexOf(key) === -1 && (!isFunction || fn(val, key, obj)))) {
      res[key] = val;
    }
  }
  return res;
};

const isUnicode = (str) => {
  let letters = [];
  for (let i = 0; i <= str.length; i++) {
    letters[i] = str.substring((i - 1), i);
    if (letters[i].charCodeAt() > 255) { return true; }
  }
  return false;
};

module.exports = {
  isEqual,
  compact,
  omit,
  isObject,
  isUnicode
};
